import { Routes } from '@/lib/routes';

export const FREE_IMAGE_TRIAL_WELCOME = 'free-image';

export const FREE_IMAGE_TRIAL_PROMPT =
  'Create a polished product hero image of a matte black wireless headphone ' +
  'on a clean studio desk, warm rim light, soft shadow, crisp commercial ' +
  'photography, premium social ad style.';

export function getFreeImageTrialHref(prompt = FREE_IMAGE_TRIAL_PROMPT) {
  const params = new URLSearchParams({
    aspectRatio: '1:1',
    model: 'grok-imagine',
    prompt,
    resolution: '1k',
    welcome: FREE_IMAGE_TRIAL_WELCOME,
  });

  return `${Routes.Generate}?${params.toString()}`;
}
